import { Component, inject, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { fromToolbar, ToolbarActions } from 'shared/classroom/toolbar/data-access';
import { ToolbarButtonComponent } from '../toolbar-button.component';
import { ClickOutsideDirective } from 'shared/ui/directives';
import { ColorPaletteComponent } from '../../color-palette/color-palette.component';
import { NgClass, AsyncPipe } from '@angular/common';

@Component({
    selector: 'pcp-slide-sync-toolbar-button-color-palette',
    templateUrl: './toolbar-button-color-palette.component.html',
    styleUrls: ['./toolbar-button-color-palette.component.scss'],
    imports: [ToolbarButtonComponent, ClickOutsideDirective, ColorPaletteComponent, NgClass, AsyncPipe]
})
export class ToolbarButtonColorPaletteComponent {

    @Input({required: true}) icon = '';
    @Input() fontSet = '';

    private readonly store: Store = inject(Store);

    readonly isColorPaleteActivated$ = this.store.select(
        fromToolbar.isColorPaleteActivated
    );

    readonly isDrawingEnabled$ = this.store.select(
        fromToolbar.isDrawingEnabled
    );

    readonly strokeColor$ = this.store.select(fromToolbar.selectStrokeColor);

    toggleColorPalette() {
        this.store.dispatch(ToolbarActions.toggleColorPalette());
    }

    /** Hide the color palette. As it internally calls "toggle", this method should only be called if the color palette is currently activated. */
    hideColorPalette = () =>
        this.store.select(fromToolbar.isColorPaleteActivated);
}
